import { render, staticRenderFns } from "./form_factor.vue?vue&type=template&id=34464460&scoped=true&"
import script from "./form_factor.vue?vue&type=script&lang=js&"
export * from "./form_factor.vue?vue&type=script&lang=js&"
import style0 from "./form_factor.vue?vue&type=style&index=0&id=34464460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34464460",
  null
  
)

export default component.exports